import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

var headers_object = new HttpHeaders({
  'Content-Type': 'application/json',

});

const httpOptions = {
  headers: headers_object
};

@Injectable()
export class DashboardService {

  share_companybase_singleBar_data: any;
  autoEnabled:boolean = false;

  projects: any[];
  widgets: any[];
  baseURL = environment.baseURL;
  // getMonthBasedURL = this.baseURL + '/' + environment.MonthBasedMethod;
  getProductBasedURL = this.baseURL + '/' + environment.ProductBasedMethod;
  getBranchBasedURL = this.baseURL + '/' + environment.BranchBasedMethod;
  getBranchByPieChartURL = this.baseURL + '/' + environment.BranchBasedMethodByPieChart;
  getRepaymentCompanybasePeriodDropdownURL = this.baseURL + '/' + environment.RepayPeriodDropdownDetailsCB;
  barchartAutorepayment = this.baseURL + '/' + environment.barchartAutorepayment;
  barchartAutorepaymentTable = this.baseURL + '/' + environment.barchartAutorepaymentTableData;
  getRepaymentProgressChartURL = this.baseURL + '/' + environment.RepaymentProgressChart;
  getRepaymentProgressChartTableURL= this.baseURL + '/' + environment.RepaymentProgressChartTable;
  repayCBpiechartURL = this.baseURL + '/' + environment.RepayCBpieChart;
  repaymentcompanybaseLinechartCPBURL = this.baseURL + '/' + environment.repaymentcompanybaseLinechartCPB;
  companyBaserepairymenttableURL =this.baseURL+'/'+environment.companybaserepairymenttable;
  CBRepaymentTableSecondPageURL = this.baseURL+'/'+environment.cbrepairymenttableSecondPage;
  repaymentCompanyBaseLineChartTable = this.baseURL + '/' + environment.repaymentCompanyBaseLineChartTableData;

  RepaymentCompanyBaseBranchBasedBarChart = this.baseURL + '/' + environment.RepaymentCompanyBaseBranchBasedBarChart;
  RepaymentCompanyBaseBranchBasedBarChartTableData = this.baseURL + '/' + environment.RepaymentCompanyBaseBranchBasedBarChartTableData;
  CompanyDetailsFilterFirstBaseURL = this.baseURL + '/' + environment.CompanyDetailsFilterFirstBase;
  RepaymentCompanyBaseBranchBasedLineChartURL = this.baseURL + '/' + environment.RepaymentCompanyBaseBranchBasedLineChart;
  repaymentDonutChartURL = this.baseURL + '/' + environment.repaymentDonutChart;
  RepaymentCompanyBaseBranchBasedLineChartTableDataURL = this.baseURL + '/' + environment.RepaymentCompanyBaseBranchBasedLineChartTableData;
  repaymentDonutChartTableDataURL = this.baseURL + '/' + environment.repaymentDonutChartTableData;
  companyBaserepairymentbranchwisetableURL = this.baseURL + '/' + environment.companyBaserepairymentbranchwisetable;
  RepaymentCompanyBaseBranchBasedprogressChartURL = this.baseURL + '/' + environment.RepaymentCompanyBaseBranchBasedprogressChart;
  RepaymentTopTenAccNumberChartURL= this.baseURL + '/' + environment.RepaymentTopTenprogressChart;
  RepaymentTopTenAccNumberTableURL= this.baseURL + '/' + environment.RepaymentTopTenprogressTable;
  RepaymentCompanyBaseBranchBasedProgressTableDataURL =  this.baseURL + '/' + environment. RepaymentCompanyBaseBranchBasedProgressTable;
  repaymentTopTenPieChartURL = this.baseURL + '/' + environment.repaymentTopTenPieChart;
  SourceNumberDetailsFilterBaseURL = this.baseURL + '/' + environment.repaymentSourceNumberValue;

  // Autotransfer
  CompanyBaseBranchBasedDonutChart = this.baseURL + '/' + environment.CompanyBaseBranchBasedDonutChart
  CompanyBaseBranchBasedDonutChartTableData = this.baseURL + '/' + environment.CompanyBaseBranchBasedDonutChartTableData;
  CompanyBaseBranchBasedBarChart = this.baseURL + '/' + environment.CompanyBaseBranchBasedBarChart;
  CompanyBaseBranchBasedBarChartTableData = this.baseURL + '/' + environment.CompanyBaseBranchBasedBarChartTableData;
  CompanyBaseBranchBasedLineChart = this.baseURL + '/' + environment.CompanyBaseBranchBasedLineChart;
  CompanyBaseBranchBasedLineChartTableData = this.baseURL + '/' + environment.CompanyBaseBranchBasedLineChartTableData;
  CompanyBaseBranchBasedProgressChart = this.baseURL + '/' + environment.CompanyBaseBranchBasedProgressChart;
  CompanyBaseBranchBasedProgressChartTableData = this.baseURL + '/' + environment.CompanyBaseBranchBasedProgressChartTableData;




  CompanyBaseTableDataAtFgURL = this.baseURL + '/' + environment.CompanyBaseTableDataAtFg;
  companybaseMonthwiselistURL = this.baseURL + '/' + environment.companybaseMonthwiselist;
  autoTransferCompanybaseFilterURL= this.baseURL + '/' + environment. autoTransferCompanybaseFilter;
  atIndividualFilterURL= this.baseURL + '/' + environment.atIndividualFilter;
  companybaseBarchartURL = this.baseURL + '/' + environment.companybaseBarchart;
  companybaseLinechartURL = this.baseURL + '/' + environment.companybaseLinechart;
  CompanyBasePieChartURL = this.baseURL + '/' + environment.CompanyBasePieChart;
  CompanyBaseProgressChartURL = this.baseURL + '/' + environment.CompanyBaseProgressChart;
  CompanyBaseBarChartTableDataURL = this.baseURL + '/' + environment.CompanyBaseBarChartTableData;
  CompanyBaseLineChartTableDataURL = this.baseURL + '/' + environment.CompanyBaseLineChartTableData;
  CompanyBasePieChartTableDataURL = this.baseURL + '/' + environment.CompanyBasePieChartTableData;
  CompanyBaseProgressChartTableDataURL = this.baseURL + '/' + environment.CompanyBaseProgressChartTableData;

  
  // AT 3red group
  individualBaseAutotransferTgTableURL =  this.baseURL + '/' + environment.individualBaseAutotransferTgTableValue;
  individualBaseAutotransferTgDougnutURL = this.baseURL + '/' + environment.individualBaseAutotransferTgDougnutValue;
  individualBaseAutotransferTgLineURL = this.baseURL + '/' + environment.individualBaseAutotransferTgLineValue;
  individualBaseAutotransferTgBarURL = this.baseURL + '/' + environment.individualBaseAutotransferTgBarValue;
  individualBaseAutotransferTgProgressURL = this.baseURL + '/' + environment.individualBaseAutotransferTgProgressValue;
  individualBaseAutotransferTgDougnutTableURL = this.baseURL + '/' + environment.individualBaseAutotransferTgProgressTableValue;
  individualBaseAutotransferTgLineTableURL = this.baseURL + '/' + environment.individualBaseAutotransferTgLineTableValue;
  individualBaseAutotransferTgbarTableURL = this.baseURL + '/' + environment.individualBaseAutotransferTgbarTableValue

  CompanyBaseBranchWiseATTAableURL=  this.baseURL + '/' + environment.CompanyBaseBranchWiseATTAable;
  ATCbBwProgressTableDataURL=  this.baseURL + '/' + environment.ATCbBwProgressTableData;
  ATindividualProgressTableDataURL=  this.baseURL + '/' + environment.ATindividualProgressTableData;
  individualBaseATTgBarTableURL=  this.baseURL + '/' + environment.individualBaseATTgBarTable;

  /**
   * Constructor
   *
   * @param {HttpClient} _httpClient
   */
  constructor(
    private _httpClient: HttpClient
  ) {

    

  }



// AT - SG

CompanyBaseBranchBasedDonutCharts(data): Observable<any>{
  return this._httpClient.post<any>(this.CompanyBaseBranchBasedDonutChart, data, httpOptions);
}
CompanyBaseBranchBasedDonutCharttable(data): Observable<any>{
  return this._httpClient.post<any>(this.CompanyBaseBranchBasedDonutChartTableData, data, httpOptions);
}


CompanyBaseBranchBasedBarCharts(data): Observable<any>{
  return this._httpClient.post<any>(this.CompanyBaseBranchBasedBarChart, data, httpOptions);
}


CompanyBaseBranchBasedBarChartTableDatas(data): Observable<any>{
  return this._httpClient.post<any>(this.CompanyBaseBranchBasedBarChartTableData, data, httpOptions);
}

CompanyBaseBranchBasedLineCharts(data): Observable<any>{
  return this._httpClient.post<any>(this.CompanyBaseBranchBasedLineChart, data, httpOptions);
}


CompanyBaseBranchBasedLineChartTableDatas(data): Observable<any>{
  return this._httpClient.post<any>(this.CompanyBaseBranchBasedLineChartTableData, data, httpOptions);
}




CompanyBaseBranchBasedProgressCharts(data): Observable<any>{
  return this._httpClient.post<any>(this.CompanyBaseBranchBasedProgressChart, data, httpOptions);
}


CompanyBaseBranchBasedProgressChartTableDatas(data): Observable<any>{
  return this._httpClient.post<any>(this.CompanyBaseBranchBasedProgressChartTableData, data, httpOptions);
}



  // getMonthBasedData(params): Observable<any> {
  //   return this._httpClient.post<any>(this.getMonthBasedURL, params, httpOptions);
  // }

  getProductBasedData(params): Observable<any> {
    return this._httpClient.post<any>(this.getProductBasedURL, params, httpOptions);
  }

  getBranchBasedData(params): Observable<any> {
    return this._httpClient.post<any>(this.getBranchBasedURL, params, httpOptions);
  }
  getBranchBasedByPieChart(params): Observable<any> {
    return this._httpClient.post<any>(this.getBranchByPieChartURL, params, httpOptions);
  }

  RepayCBdashboardPeriodDropdown(): Observable<any> {
    return this._httpClient.get<any>(this.getRepaymentCompanybasePeriodDropdownURL);
  }

  barchartAutorepayments(params): Observable<any> {
    return this._httpClient.post<any>(this.barchartAutorepayment, params, httpOptions);
  }

  barchartAutorepaymentTables(params): Observable<any> {
    return this._httpClient.post<any>(this.barchartAutorepaymentTable, params, httpOptions);
  }

  autoRepaymentProgressChart(data): Observable<any>{
    return this._httpClient.post<any>(this.getRepaymentProgressChartURL, data, httpOptions);
  }

  autoRepaymentProgressChartTable(data): Observable<any>{
    return this._httpClient.post<any>(this.getRepaymentProgressChartTableURL, data, httpOptions);
  }
  
  repayCBpiechart(data): Observable<any>{
    return this._httpClient.post<any>(this.repayCBpiechartURL, data, httpOptions);
  }
  

  repaymentcompanybaseLinechartCPB(params): Observable<any> {
    
    return this._httpClient.post<any>(this.repaymentcompanybaseLinechartCPBURL, params, httpOptions)
  }

  companyBaseRepaymentTable(params):Observable<any>{
    return this._httpClient.post<any>(this.companyBaserepairymenttableURL , params , httpOptions )
  }

  CBRepaymentTableSecondPage(params):Observable<any>{
    return this._httpClient.post<any>(this.CBRepaymentTableSecondPageURL , params , httpOptions )
  }

  RepaymentCompanyBaseLineChartTableData(params): Observable<any> {
    return this._httpClient.post<any>(this.repaymentCompanyBaseLineChartTable, params, httpOptions);
  }

  // Second Group

  RepaymentCompanyBaseBranchBasedBarCharts(params): Observable<any> {
    return this._httpClient.post<any>(this.RepaymentCompanyBaseBranchBasedBarChart, params, httpOptions);
  }

  RepaymentCompanyBaseBranchBasedBarChartTableDatas(params): Observable<any> {
    return this._httpClient.post<any>(this.RepaymentCompanyBaseBranchBasedBarChartTableData, params, httpOptions);
  }

  CompanyDetailsFilterFirstBase(params): Observable<any> {
    return this._httpClient.post<any>(this.CompanyDetailsFilterFirstBaseURL, params, httpOptions);
  }
  RepaymentCompanyBaseBranchBasedLineChart(params): Observable<any> {
    return this._httpClient.post<any>(this.RepaymentCompanyBaseBranchBasedLineChartURL, params, httpOptions);
  }

  repaymentDonutChart(data): Observable<any>{
    return this._httpClient.post<any>(this.repaymentDonutChartURL, data, httpOptions);
  }

  RepaymentCompanyBaseBranchBasedLineChartTableData(params): Observable<any> {
    return this._httpClient.post<any>(this.RepaymentCompanyBaseBranchBasedLineChartTableDataURL, params, httpOptions);
  }
  RepaymentCompanyBaseBranchBasedProgressTableData(params):Observable<any>{
    return this._httpClient.post<any>(this.RepaymentCompanyBaseBranchBasedProgressTableDataURL , params , httpOptions )
  }

  repaymentDonutChartTable(data): Observable<any>{
    return this._httpClient.post<any>(this.repaymentDonutChartTableDataURL, data, httpOptions);
  }
  companyBaseRepaymentBranchwiseTable(params):Observable<any>{
    return this._httpClient.post<any>(this.companyBaserepairymentbranchwisetableURL , params , httpOptions )
  }

  arProgressChartcmpybase(params):Observable<any>{
    return this._httpClient.post<any>(this.RepaymentCompanyBaseBranchBasedprogressChartURL , params , httpOptions )
  }

  arProgressChartTopTen(params):Observable<any>{
    return this._httpClient.post<any>(this.RepaymentTopTenAccNumberChartURL , params , httpOptions )
  }

  TopTenAccountNumber(params):Observable<any>{
    return this._httpClient.post<any>(this.RepaymentTopTenAccNumberTableURL , params , httpOptions )
  }

  repaymentTopTenPieChart(data): Observable<any>{
    return this._httpClient.post<any>(this.repaymentTopTenPieChartURL, data, httpOptions);
  }

  
  SourceNumberDetailsFilterBase(params): Observable<any> {
    return this._httpClient.post<any>(this.SourceNumberDetailsFilterBaseURL, params, httpOptions);
  }

  CompanyBaseTableDataAtFg(params): Observable<any> {
    return this._httpClient.post<any>(this.CompanyBaseTableDataAtFgURL, params, httpOptions);
  }
  
  companybaseMonthwiselistAtFg(params): Observable<any> {
    return this._httpClient.post<any>(this.companybaseMonthwiselistURL, params, httpOptions);
  }

  companybaseBarchart(params): Observable<any> {
    return this._httpClient.post<any>(this.companybaseBarchartURL, params, httpOptions);
  }

  CompanyDetailsAutoTransferFilter(params): Observable<any> {
    return this._httpClient.post<any>(this.autoTransferCompanybaseFilterURL, params, httpOptions);
  }
  
  ATIndividualFilter(params): Observable<any> {
    return this._httpClient.post<any>(this.atIndividualFilterURL, params, httpOptions);
  }
  companybaseLinechart(params): Observable<any> {
    return this._httpClient.post<any>(this.companybaseLinechartURL, params, httpOptions);
  }

  CompanyBasePieChart(params): Observable<any> {
    return this._httpClient.post<any>(this.CompanyBasePieChartURL, params, httpOptions);
  }

  CompanyBaseProgressChart(params): Observable<any> {
    return this._httpClient.post<any>(this.CompanyBaseProgressChartURL, params, httpOptions);
  }
  
  CompanyBaseBarChartTableData(params): Observable<any> {
    return this._httpClient.post<any>(this.CompanyBaseBarChartTableDataURL, params, httpOptions);
  }

  CompanyBaseLineChartTableData(params): Observable<any> {
    return this._httpClient.post<any>(this.CompanyBaseLineChartTableDataURL, params, httpOptions);
  }

  CompanyBasePieChartTableData(params): Observable<any> {
    return this._httpClient.post<any>(this.CompanyBasePieChartTableDataURL, params, httpOptions);
  }
  
  CompanyBaseProgressChartTableData(params): Observable<any> {
    return this._httpClient.post<any>(this.CompanyBaseProgressChartTableDataURL, params, httpOptions);
  }
  
  // AT 3rd Group

  individualBaseAutotransferTgTable(params):Observable<any>{
    return this._httpClient.post<any>(this.individualBaseAutotransferTgTableURL , params , httpOptions )
  }

  individualBaseAutotransferTgDougnut(params):Observable<any>{
    return this._httpClient.post<any>(this.individualBaseAutotransferTgDougnutURL , params , httpOptions )
  }

  individualBaseAutotransferTgLine(params):Observable<any>{
    return this._httpClient.post<any>(this.individualBaseAutotransferTgLineURL , params , httpOptions )
  }

  individualBaseAutotransferTgBar(params):Observable<any>{
    return this._httpClient.post<any>(this.individualBaseAutotransferTgBarURL , params , httpOptions )
  }
  individualBaseAutotransferTgBarTable(params):Observable<any>{
    return this._httpClient.post<any>(this.individualBaseATTgBarTableURL , params , httpOptions )
  }

  individualBaseAutotransferTgProgress(params):Observable<any>{
    return this._httpClient.post<any>(this.individualBaseAutotransferTgProgressURL , params , httpOptions )
  }

  individualBaseAutotransferTgDougnutTable(params):Observable<any>{
    return this._httpClient.post<any>(this.individualBaseAutotransferTgDougnutTableURL , params , httpOptions )
  }

  individualBaseAutotransferTgLineTable(params):Observable<any>{
    return this._httpClient.post<any>(this.individualBaseAutotransferTgLineTableURL , params , httpOptions )
  }

  individualBaseAutotransferTgbarTable(params):Observable<any>{
    return this._httpClient.post<any>(this.individualBaseAutotransferTgbarTableURL , params , httpOptions )
  }
  



  // ///////////

  CompanyBaseBranchWiseAutoTransferTable(params):Observable<any>{
    return this._httpClient.post<any>(this.CompanyBaseBranchWiseATTAableURL , params , httpOptions )
  }


  ATCbBwProgressTableData(params):Observable<any>{
    return this._httpClient.post<any>(this.ATCbBwProgressTableDataURL , params , httpOptions )
  }

  ATIndividualProgressTableData(params):Observable<any>{
    return this._httpClient.post<any>(this.ATindividualProgressTableDataURL , params , httpOptions )
  }
}
